<template>
  <div class="modal-backdrop">
    <div class="card borderradius10 col-lg-4 col-md-8 mt-md-4 col-11 p-0 mx-auto" v-if="!displayAPIerrorModal">
      <div class="modal-content border-0" v-if="!videoisselected">
        <div class="modal-header p-3">
          <h4 class="modal-title titlemodal fontsize16" v-if="profileresume.videoType === 'resumevid'">Resume video</h4>
          <h4 class="modal-title titlemodal fontsize16" v-if="profileresume.videoType === 'profilevid'">Profile video</h4>
          <!-- <button type="button" class="close" @click="close">&times;</button> -->
          <button type="button" class="close" @click="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="alert-danger alert-danger1 text-center" v-if="videoUploadingErrorMessage">{{videoUploadingErrorMessage}}</div>
        <div class="modal-body bodymodal1">
          <div class="p-5 text-center">
            <!-- <div class="contentA pb-2 d-none d-lg-block"> -->
            <div class="hiderecorddevcam">
              <div class="white60 fontsize14 proximanova pb-3" v-if="profileresume.videoType === 'resumevid'">Video must be between 45 to 120 seconds long.</div>
              <div class="white60 fontsize14 proximanova pb-3" v-if="profileresume.videoType === 'profilevid'">Video must be between 15 to 60 seconds long.</div>
              <button class="sign-in-button border-0 p-2 pl-3 pr-3 modalbtn" @click="recordpostvideo">Record Video</button>
            </div>
            <!-- <div class="contentA pb-2 d-block d-lg-none"> -->
            <div class="displayrecorddevcam">
              <div class="white60 fontsize14 proximanova pb-3" v-if="profileresume.videoType === 'resumevid'">Video must be between 45 to 120 seconds long.</div>
              <div class="white60 fontsize14 proximanova pb-3" v-if="profileresume.videoType === 'profilevid'">Video must be between 15 to 60 seconds long.</div>
              <input
                type="file"
                class="form-control-file"
                id="profileresumesm"  multiple  accept="video/*" capture @change="onFilechangeSelected2"
                @click="recordvideosm()"
                hidden
              />
              <button class="sign-in-button border-0 p-2 pl-3 pr-3" @click="recordvideosm()">Record Video</button>
            </div>
            <div class="contentB pt-3">
              <div class="white60 fontsize14 proximanova pb-3"> Do you have a video already ?  </div>
                <input
                  type="file"
                  class="form-control-file"
                  id="profileresume"  multiple  accept="video/mp4,video/x-m4v,video/*" @change="onFilechangeSelected2"
                  @click="chooseFilesopen()"
                  hidden
                />
                <button class="blackbackhround border-light borderradius20 p-2 pl-3 pr-3" @click="chooseFilesopen()">Upload Video</button>
              </div>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default modalbtn borderradius20 border focusnone" @click="close">Cancel</button>
        </div>
      </div>
      <div class="modal-content border-0 modal-height" v-if="videoisselected">
        <div class="modal-header p-4">
          <h4 class="modal-title fontsize16 black80 proximanova-bold" v-if="profileresume.videoType === 'resumevid'">Resume video</h4>
          <h4 class="modal-title fontsize16 black80 proximanova-bold" v-if="profileresume.videoType === 'profilevid'">Profile video</h4>
          <!-- <button type="button" class="close m-0" @click="close">&times;</button> -->
          <button type="button" class="close" @click="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="alert-danger alert-danger1 text-center proximanova" v-if="videoUploadingErrorMessage">{{videoUploadingErrorMessage}}</div>
        <div class="modal-body bodymodal2 videomodalbody2 container-fluid videoprofile" :class="{ 'recordsection': recordvideosection, 'overflowy':!recordvideosection }" id="videomodalbody2">
          <div class="col-12 p-0">
            <video autoplay :controls="!hideVideoControls" height="280" preload="metadata" controlsList="nodownload"  id="vidprofileresume" >
              <source id="sourcepost" type="video/mp4">
              <source id="sourcepost" type="video/quicktime">
              <source id="sourcepost" type="video/webm">
            </video>
            <div class="btn-group dropup">
              <div class="editbtn1 borderradius10 backgroundcolorwhite d-flex justify-content-between pl-2 pr-2" v-if="recordvideosection">
                <img src="../assets/video_recording.gif" width="30px" height="30px" alt="video recording" v-if="startedRcording"> 
                <img src="../assets/video_recording_pause.png" width="30px" height="30px" alt="pause recording" v-else>
                <span class="black fontsize12 proximanova text-nowrap mt-2 ml-1 mr-1">{{totalSeconds}} Sec</span>
              </div>
              <button type="button" id="togglebutton" v-if="!recordvideosection" class="btn btn-default border editbtn proximanova dropdown-toggle focusnone" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Edit
              </button>
              <div class="dropdown-menu dropdown-menu-right editdropdown">
                <span @click="gotoRecordSection" class="d-block d-lg-none proximanova">
                  <div class="proximanova">Record</div>
                  <input
                  type="file"
                  class="form-control-file"
                  id="profileresumeonvideomodalsm"  multiple  accept="video/*" capture @change="onFilechangeSelected2"
                  @click="gotoRecordSection()"
                  hidden
                />
                </span>
                <span  @click="recordpostvideo" class="d-none d-lg-block proximanova">Record</span>
                <span @click="gotoUploadvideo">
                  <div class="proximanova">Upload</div>
                  <input
                  type="file"
                  class="form-control-file"
                  id="profileresume"  multiple  accept="video/mp4,video/x-m4v,video/*" @change="onFilechangeSelected2"
                  @click="chooseFilesopen()"
                  hidden
                />
                </span>
                <span @click="gotoDeleteVideo" class="proximanova">Delete</span>
              </div>
            </div>
          </div>
          <div class="addVideoDetails d-flex" v-if="!recordvideosection">
            <div class="col-3 videoSideMenu p-2 pl-3" v-if="!videoDetailsSection">
              <div class="d-flex pt-0">
                <img src="../assets/Filters.svg" class="img-fluid" alt="filters">
                <p class="black60 fontsize12 proximanova-semibold pl-1 my-auto">Filters</p>
              </div>
              <div class="d-flex mt-3">
                <img src="../assets/Music.svg" class="img-fluid" alt="music">
                <p class="black60 fontsize12 proximanova-semibold pl-1 my-auto">Music</p>
              </div>
              <div class="d-flex mt-3">
                <img src="../assets/Text.svg" class="img-fluid" alt="text">
                <p class="black60 fontsize12 proximanova-semibold pl-1 my-auto">Text</p>
              </div>
              <div class="d-flex mt-3 mb-2">
                <img src="../assets/Elements.svg" class="img-fluid" alt="elements">
                <p class="black60 fontsize12 proximanova-semibold pl-1 my-auto">Elements</p>
              </div>
            </div>
            <div class="col-12 videomenusection pb-2" v-if="videoDetailsSection">
              <!-- <div class="d-flex flex-column">
                <div class="d-flex pt-2">
                  <p class="font12-opacity60">Thumbnail</p>
                  <span class="font10-opacity80 thumbnailtext">(Upload or Select a thumbnail that shows what's in your video profile.)</span>
                </div>
                <div class="d-flex">
                  <div class="d-flex flex-column thumbnailbtn rounded text-center p-1">
                    <input
                      type="file"
                      class="form-control-file"
                      id="profileresumethumbnail"  multiple  accept="image/*" @change="selectprofileresumevideothumbnail"
                      @click="choosepostVideoThumbnail()"
                      hidden
                    />
                    <img src="../assets/upload_thumbnail.svg" @click="choosepostVideoThumbnail()" class="img-fluid ml-4" width="30px" alt="">
                    <span class="font10-opacity80">Upload Thumbnail</span>
                  </div>
                  <div>
                    <img :src="profileresumevideothumbnail" id="videoprofileresumeThumbnail" height="54px" class="ml-2"  alt="">
                  </div>
                </div>
              </div> -->
              <div class="d-flex flex-column pt-2">
                <span class="black60 fontsize12 proximanova-semibold mb-1">Details</span>
                <input type="text" v-model="videoTitle" placeholder="Title *" @input="checkVedioSaveButton" class="p-1 mb-1 mt-1 videotitle rounded proximanova" name="" id="">
                <textarea name="description" v-model="videoDescription" @input="checkVedioSaveButton" id="videodescription" class="p-1 mt-1 videodescription proximanova rounded" placeholder="Description *" cols="30" rows="3"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <div v-if="!againRecordVideoBtnClicked && !selectVideoFromLocal">
          <div v-if="!selectVideoFromLocal && recordvideosection" class="d-flex justify-content-between">
            <button class="d-flex btn focusnone" id="btn_start_record" v-if="beforeRcording && !startcamwithrecBtnDisplay" @click="startVideoRecordingClicked">
              <img src="../assets/StartRecording.svg" alt="startrecording">
              <span class="recordbtn proximanova starttext mt-1 ml-1">Start Recording</span>
            </button>
            <button class="d-flex btn focusnone" id="btn_start_record" v-if="startcamwithrecBtnDisplay" @click="openConfirmModalToRecordVideoAgain">
              <img src="../assets/StartRecording.svg" alt="startrecording">
              <span class="recordbtn proximanova starttext mt-1 ml-1">Start Recording</span>
            </button>
            <button class="d-flex btn focusnone" id="btn_pause_record" v-if="startedRcording" @click="pauseVideoRecording">
              <img src="../assets/Pause_Recording.svg" alt="pauserecording">
              <span class="recordbtn proximanova mt-1 ml-1">Pause Recording</span>
            </button>
            <button class="d-flex btn focusnone" id="btn_resume_record" v-if="recordingPaused" @click="resumeVideoRecording">
              <img src="../assets/Pause_Recording.svg" alt="resumerecording">
              <span class="recordbtn proximanova mt-1 ml-1">Resume Recording</span>
            </button>
            <button class="d-flex btn focusnone" id="btn_stop_record" @click="stopVideoRecording">
              <img src="../assets/Stop_Recording.svg" alt="stoprecording">
              <span class="recordbtn proximanova mt-1 ml-1">Stop Recording</span>
            </button>
            <button @click="moveToEdit" id="moveToEdit1" :disabled="movetoeditdisable" class="button-cancel-font mouseoverbtn1 fontsize14 pointer border borderradius20 p-1 pr-4 pl-4 proximanova ml-lg-5 backgroundnone">Next</button>
          </div>
          </div>
          <div v-if="againRecordVideoBtnClicked && !selectVideoFromLocal">
            <div class="d-flex">
              <div class="col-8 pl-0">
                <h5 class="modal-title fontsize16 black80 proximanova" id="deleteLikeVideoModalLabel">Are you sure you want to override the existing recorded video ?</h5>
              </div>
              <div class="col-4 pl-0 my-auto pr-0">
                <span class="button-cancel-font mouseoverbtn1 fontsize14 pointer border borderradius20 p-2 pr-4 pl-4 proximanova" @click="keepPreviousRecordedVideo" >No</span>
                <span class="btn focusnone backgroundcolorblack p-1 white mouseoverbtn2 fontsize14 pointer white ml-2 pr-4 pl-4 borderradius20 proximanova" @click="startCamWithVideoRecording">Yes</span>
              </div>
            </div>
          </div>
          <div class="rerecord d-flex" v-if="selectVideoFromLocal">
            <div class="displayrecorddevcam">
              <input
                type="file"
                class="form-control-file"
                id="profileresumeonvideomodalsm"  multiple  accept="video/*" capture @change="onFilechangeSelected2"
                @click="gotoRecordSection()"
                hidden
              />
              <span class="coloredfont12 pl-2 mouseoverbtn1 proximanova pointer pr-2" @click="gotoRecordSection"> Re Record </span>
            </div>
            <span class="coloredfont12 hiderecorddevcam proximanova pointer pl-2 mouseoverbtn1 pr-2"  @click="recordpostvideo">Re Record</span>
          </div>
          <div class="btngroup justify-content-between" v-if="selectVideoFromLocal">
            <button type="button" class="btn focusnone border borderradius20 mouseoverbtn1 proximanova" @click="close">Cancel</button>
            <!-- <button type="button"  v-if="videoDetailsSection" class="btn border ml-1 mouseoverbtn1 proximanova" @click="openpostDetailsSection">Back</button>
            <button type="button" v-if="!videoDetailsSection" class="btn border  ml-1 mouseoverbtn1 proximanova" @click="openpostDetailsSection">Next</button> -->
            <img src="../assets/uploadvideo.svg" width="30px" class="img-fluid ml-1" alt="uploadingvideo" v-if="draftbuttonClicked">
            <button type="button" class="btn focusnone border borderradius20 ml-1 mouseoverbtn1 proximanova" id="draftpost" v-if="!draftbuttonClicked && profileresume.videoType === 'profilevid'" @click="draftProfileVideoBtnClicked" disabled>Draft</button>
            <button type="button" class="btn focusnone border borderradius20 ml-1 mouseoverbtn1 proximanova" id="draftpost" v-if="!draftbuttonClicked &&profileresume.videoType === 'resumevid'" @click="draftResumeVideoBtnClicked" disabled>Draft</button>
            <img src="../assets/uploadvideo.svg" width="30px" class="img-fluid ml-1" alt="uploadingvideo" v-if="savebuttonClicked">
            <button type="button" class="btn focusnone ml-1 borderradius20 proximanova mouseoverbtn2 backgroundcolorblack white" id="savepost" v-if="!savebuttonClicked && profileresume.videoType === 'profilevid'" @click="saveprofileVideoBtnClicked" disabled>Post</button>
            <button type="button" class="btn focusnone ml-1 borderradius20 proximanova mouseoverbtn2 backgroundcolorblack white" id="savepost" v-if="!savebuttonClicked && profileresume.videoType === 'resumevid'" @click="saveresumeVideoBtnClicked" disabled>Post</button>
          </div>
        </div>
      </div>
    </div> 
    <div class="card maincard col-lg-3 col-md-5 mt-md-4 col-10 p-0 borderadius12 mx-auto" v-else>
      <div class="modal-content border-0 borderadius12">
        <!-- <div class="modal-header">          
          <h5 class="modal-title font16-bold ml-2" id="exampleModalLabel"></h5>  
          <button type="button" class="closebtn" @click="close" data-dismiss="modal" aria-label="Close">&times;
          </button>
        </div> -->
        <div class="modal-body p-5 pb-5">
          <div class="d-flex flex-column text-center">
            <!-- <img src="../assets/information.gif" class="col-3 img-fluid mx-auto" alt=""> -->
            <span class="proximanova-bold fontsize18 black">Error</span>
            <span class="mt-2 proximanova fontsize16 black60">Oops, Something went wrong.</span>
            <span class="mt-1 proximanova fontsize16 black60">Please try again later.</span>
            <button class="backgroundcolor3 white borderradius20 bordernone proximanova mt-4 p-1 borderadius12" @click="close" data-dismiss="modal" aria-label="Close">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import htttpuserprofile from "@/js/http-userprofile.js";
import { bus } from "../main";
import sessionUtils from '@/js/session-util.js'
import $ from 'jquery'
export default {
  props : [
      'profileresume'
  ],
  data() {
    return{
      displayAPIerrorModal : false,
      videoisselected : false,
      videoDetailsSection : true,
      //vid record
      hideVideoControls : true,
      startcamwithrecBtnDisplay : false,
      recordvideosection : false,
      beforeRcording : true,
      startedRcording : false,
      recordingPaused : false,
      postrecordVideo : null,
      postrecorder : null,
      totalSeconds : 0,
      timer : null,
      setSource : null,
      movetoeditdisable : true,
      savebuttonClicked : false,
      againRecordVideoBtnClicked : false,
      selectVideoFromLocal : false,
      videoUploadingErrorMessage : null,
      videoTitle : '',
      videoDescription : '',
      profileresumevideothumbnail : null,
      selectedpostVideo : null,
      selectedpostvideoduration : null,
      privacy : 'PUBLIC',
      profileId : null,
      videoType : 'POST',
      savebuttonClicked : false,
      draftbuttonClicked : false
    }
  },
  mounted() {
    this.profileId=sessionUtils.getUserProfileId()
  },
  methods: {
    //this will invoke after click on close button/ cancel button 
    close() {
      var videoElement = document.getElementById('vidprofileresume');
      if(videoElement) {
        videoElement.pause();
        videoElement.removeAttribute('src'); // empty source
        videoElement.load();
      }
      this.$emit('close');
    },
    keepPreviousRecordedVideo() {
      this.againRecordVideoBtnClicked = false;
    },
    openConfirmModalToRecordVideoAgain(){
      this.againRecordVideoBtnClicked = true;
    },
    startCamWithVideoRecording(){
      this.againRecordVideoBtnClicked = false;
      var that = this;
      this.postrecordVideo = document.getElementById('vidprofileresume')
      // get camera access
      captureCamera(function(camera) {
        that.postrecordVideo.muted = true;
        that.postrecordVideo.volume = 0;
        that.postrecordVideo.srcObject = camera;
        that.postrecorder = RecordRTC(camera, {
            type: 'video',
            mimeType: 'video/webm',
            timeSlice: 1000
        });
        // that.runTimer();
        //stop recording when rach to 120 sec
        var recordingDuration = 120000;
        that.postrecorder.setRecordingDuration(recordingDuration).onRecordingStopped(stopRecordingCallback);
    
        that.postrecorder.startRecording();
        that.runTimer()
        that.totalSeconds = 0;
        that.beforeRcording = false;
        that.startcamwithrecBtnDisplay = false;
        that.movetoeditdisable = true;
        that.hideVideoControls = true;
        that.startedRcording = true;
        that.recordingPaused = false;
        that.postrecorder.camera = camera;
      });
      function captureCamera(callback) {
        navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(function(camera) {
            callback(camera);
        }).catch(function(error) {
          console.error(error);
          that.$toast.info('Unable to capture your camera. Please use other way to upload video'); 
        });
      }
      function stopRecordingCallback() {
        console.log("enter")
          document.getElementById('moveToEdit').disabled = false
          that.postrecordVideo.src = that.postrecordVideo.srcObject = null;
          that.postrecordVideo.muted = false;
          that.postrecordVideo.volume = 1;
          that.postrecordVideo.src = URL.createObjectURL(that.postrecorder.getBlob());
          console.log(that.postrecorder)
          that.beforeRcording = true;
          that.startcamwithrecBtnDisplay = true;
          that.startedRcording = false;
          that.recordingPaused = false;
          that.movetoeditdisable = false;
          that.setSource = URL.createObjectURL(that.postrecorder.getBlob())
          that.selectedpostVideo = that.postrecorder.getBlob()

          that.postrecorder.camera.stop();
          clearInterval(that.timer)
          that.postrecorder = null;
      }
    },
    //// video recording functionality
    // get camera access
    // stop recording based on profile/resume video and duration
    startVideoRecording : function() {
      console.log("start recording")
      var that = this;
      // var dateStarted;
      // var recorder;
      this.postrecordVideo = document.getElementById('vidprofileresume')
      captureCamera(function(camera) {
        that.postrecordVideo.muted = true;
        that.postrecordVideo.volume = 0;
        that.postrecordVideo.srcObject = camera;
        that.postrecorder = RecordRTC(camera, {
            type: 'video',
            mimeType: 'video/webm',
            timeSlice: 1000
        });
        //that.runTimer();
        if(that.profileresume.videoType === 'profilevid') {
          var recordingDuration = 60000;
          that.postrecorder.setRecordingDuration(recordingDuration).onRecordingStopped(stopRecordingCallback);
        }
        if(that.profileresume.videoType === 'resumevid') {
          //stop recording when rach to 120 sec
          var recordingDuration = 120000;
          that.postrecorder.setRecordingDuration(recordingDuration).onRecordingStopped(stopRecordingCallback);
        }
    
        // that.postrecorder.startRecording();
        // that.beforeRcording = false;
        // that.startedRcording = true;
        // that.recordingPaused = false;
        that.postrecorder.camera = camera;
      });
      function captureCamera(callback) {
        navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(function(camera) {
            callback(camera);
        }).catch(function(error) {
          console.error(error);
          that.$toast.info('Unable to capture your camera. Please use other way to upload video'); 
        });
      }
      function stopRecordingCallback() {
        console.log("enter")
          document.getElementById('moveToEdit1').disabled = false
          that.postrecordVideo.src = that.postrecordVideo.srcObject = null;
          that.postrecordVideo.muted = false;
          that.postrecordVideo.volume = 1;
          that.postrecordVideo.src = URL.createObjectURL(that.postrecorder.getBlob());
          console.log(that.postrecorder)
          that.beforeRcording = true;
          that.startcamwithrecBtnDisplay = true;
          that.startedRcording = false;
          that.recordingPaused = false;
          that.movetoeditdisable = false;
          that.setSource = URL.createObjectURL(that.postrecorder.getBlob())
          that.selectedpostVideo = that.postrecorder.getBlob()

          that.postrecorder.camera.stop();
          clearInterval(that.timer)
          that.postrecorder = null;
      }
    },
    //calculating duration of recording
    runTimer(){
      var that = this;
      this.timer = setInterval(tick, 1000);
      function tick(){
        that.totalSeconds++
      }
    },
    startVideoRecordingClicked : function(){
      var that = this;
      that.postrecorder.startRecording();
      that.beforeRcording = false;
      that.startcamwithrecBtnDisplay = false;
      that.startedRcording = true;
      that.recordingPaused = false;
      that.runTimer();
    },
    //pause video recording
    pauseVideoRecording : function() {
      console.log("pause recording")
      var that = this;
      that.beforeRcording = false;
      that.startcamwithrecBtnDisplay = false;
      that.startedRcording = false;
      that.recordingPaused = true;
      that.postrecorder.pauseRecording()
      clearInterval(that.timer)
    },
    //resume video recording
    resumeVideoRecording:  function() {
      console.log("resume recording")
      var that = this;
      that.beforeRcording = false;
      that.startcamwithrecBtnDisplay = false;
      that.startedRcording = true;
      that.recordingPaused = false;
      that.postrecorder.resumeRecording()
      that.runTimer()
    },
    //stop video recording
    stopVideoRecording : function() {
      console.log("stop recording")
      var that = this;
      this.startcamwithrecBtnDisplay = true;
      this.movetoeditdisable = false;
      this.hideVideoControls = false;
      this.startedRcording = false;
      document.getElementById('moveToEdit1').disabled = false
      if(that.postrecorder){
      that.postrecorder.stopRecording(stopRecordingCallback);
      }
      function stopRecordingCallback() {
          that.postrecordVideo.src = that.postrecordVideo.srcObject = null;
          that.postrecordVideo.muted = false;
          that.postrecordVideo.volume = 1;
          that.postrecordVideo.src = URL.createObjectURL(that.postrecorder.getBlob());
          console.log(that.postrecorder)
          that.beforeRcording = true;
          that.startcamwithrecBtnDisplay = true;
          that.startedRcording = false;
          that.recordingPaused = false;
          that.setSource = URL.createObjectURL(that.postrecorder.getBlob())
          that.selectedpostVideo = that.postrecorder.getBlob()

          that.postrecorder.camera.stop();
          that.selectedpostvideoduration = that.totalSeconds;
          clearInterval(that.timer)
          that.postrecorder = null;
      }
    },
    clearCameraEvent() {
      var that = this;
      if(that.postrecorder !== null){
      that.postrecorder.stopRecording(stopRecordingCallback);
      function stopRecordingCallback() {
          that.postrecordVideo.src = that.postrecordVideo.srcObject = null;
          that.postrecordVideo.muted = false;
          that.postrecordVideo.volume = 0;
          that.postrecordVideo.src = null
          that.postrecorder.camera.stop();
          clearInterval(that.timer)
          that.postrecorder = null;
      }
      that.postrecorder.camera.stop();
      }
    },
    // this will invoke after click on next button
    //display filter options after recorded a video
    moveToEdit : function() {
      console.log("move to edit")
      this.recordvideosection = false;
      this.selectVideoFromLocal = true;
      document.getElementById('videomodalbody2').style.height = '420px'
    },
    //display record video section to record a video
    recordpostvideo : function() {
      console.log("recording post video")
      this.videoisselected = true;
      this.recordvideosection = true;
      this.selectVideoFromLocal = false;
      this.movetoeditdisable = true;
      this.totalSeconds = 0;
      this.hideVideoControls = true;
      this.startcamwithrecBtnDisplay = false;
      setTimeout(() => {
      this.startVideoRecording();
      }, 1000)
      this.closeEditBtnOptions()
      document.getElementById('videomodalbody2').style.height = '240px'
      // document.getElementById('moveToEdit1').disabled = true;
    },
    chooseFilesopen() {
      document.getElementById("profileresume").click()
    },
    recordvideosm() {
      document.getElementById("profileresumesm").click()
    },
    //enable/disable video save button based on validations
    checkVedioSaveButton : function() {
      // if(this.videoTitle !== '' && this.videoDescription !=="" && this.profileresumevideothumbnail !== null){
        if(this.videoTitle !== '' && this.videoDescription !==""){
        var x = document.getElementById('savepost')
        var y = document.getElementById('draftpost')
        if(x) {
         // x.classList.add("sign-in-button")
          x.disabled = false
        }
        if(y) {
          y.disabled = false
        }
      }else{
        var x = document.getElementById('savepost')
        var y = document.getElementById('draftpost')
        if(x) {
         // x.classList.remove("sign-in-button")
          x.disabled = true
        }
        if(y) {
          y.disabled = false
        }
      }
    },
    //this will invoke after upload a video from local device
    //check the validations like :::
    // video duration
    // video size
    // video format
    onFilechangeSelected2(event){
      console.log("check : ", event.target.files)
      let that = this;
      this.selectedpostVideo = event.target.files[0]
      this.selectVideoFromLocal = true;
      this.hideVideoControls = false;
      var file = event.target.files[0];
      var fsize = file.size
      var fduration;
      var fwidth;
      var fheight;
      var ffile = Math.round((fsize / 1024 / 1024));
      var prevideo = document.createElement('video');
        prevideo.preload = 'metadata';

        prevideo.onloadedmetadata = function() {
          window.URL.revokeObjectURL(prevideo.src);
          fduration = prevideo.duration;
          that.selectedpostvideoduration = fduration
          checkDuration()
        }
      prevideo.src = webkitURL.createObjectURL(event.target.files[0]);;
      function checkDuration(){
        if(that.profileresume.videoType === 'resumevid'){
          if(fduration>45 && fduration < 120){
            that.videoUploadingErrorMessage = null;
            proccedToValidation()
          }else{
            that.videoUploadingErrorMessage = "Video must be between 45 to 120 seconds long. "
            return
          }
        }
        if(that.profileresume.videoType === 'profilevid'){
          if(fduration>15 && fduration < 60){
            that.videoUploadingErrorMessage = null;
            proccedToValidation()
          }else{
            that.videoUploadingErrorMessage = "Video must be between 15 to 60 seconds long. "
            return
          }
        }
      }
      console.log("file type : ", file.type)
      function proccedToValidation(){
        if(ffile <= 400){
          if(file.type == 'video/mp4' || file.type == 'video/quicktime' || file.type == 'video/mov' || file.type == 'video/webm') {
            that.videoisselected = true
            that.selectVideoFromLocal = true
            var reader = new FileReader();
            reader.onload = function(e){
              
              document.getElementById('videomodalbody2').style.height = '420px'
              that.recordvideosection = false;
              that.movetoeditdisable = false;
              var src = that.selectedpostVideo;
              var blob = new Blob([src], {type: 'video/mp4'});
              var url = webkitURL.createObjectURL(blob);
              console.log("url : ", url)
              var video = document.getElementById('vidprofileresume');
              var source = document.getElementById('sourcepost')
              source.setAttribute('src', url)
              var timer = setInterval(function () {
                  if (video.readyState === 4){
                    fduration = Math.round(video.duration)
                    fwidth = video.videoWidth
                    fheight = video.videoHeight
                    console.log("video duration : ", fduration)
                    console.log("video width : ", fwidth)
                    console.log("video height : ", fheight)
                    clearInterval(timer);
                  }
                }, 500)
                video.load();
                video.play()
                video.addEventListener('error', function(err){
                  // This craps out in Safari 6
                  console.error(video.error, err);
                  //alert("browser doesn't support preview");
                });
                console.log("video : ", video)
            }
            reader.readAsDataURL(file)
          }else{
            console.log("please upload valid format video")
            that.videoUploadingErrorMessage = "Video format is not valid"
          }
        }else{
          console.log("file size is less than 400mb")
          that.videoUploadingErrorMessage = "File size must be less than 400mb"
        }
      }
      
    },
    closeEditBtnOptions() {
      let button = document.getElementById("togglebutton")
      if(button) {
        button.click()
      }
    },
    gotoRecordSection : function() {
      console.log("record button clicked")
      document.getElementById('profileresumeonvideomodalsm').click()
      this.closeEditBtnOptions()
    },
    gotoUploadvideo  :function() {
      console.log("upload video button clicked")
      document.getElementById("profileresume").click()
      this.closeEditBtnOptions()
    },
    // delete recorded video
    gotoDeleteVideo : function() {
      console.log("delete video button clicked")
      var video = document.getElementById('vidprofileresume');
      var source = document.getElementById('sourcepost')
      this.selectedpostVideo = null
      video.removeAttribute('src')
      source.removeAttribute('src')
      video.load();
      this.closeEditBtnOptions()
    },
    // upload a thumbnail to a video from local
    selectprofileresumevideothumbnail : function(event) {
      console.log("selected video thumbnail : ", event.target.files)
      this.profileresumevideothumbnail = event.target.files[0]
      this.checkVedioSaveButton()
      let fileList = Array.prototype.slice.call(event.target.files);
      fileList.forEach(f => {
        if(!f.type.match("image.*")) {
  				return;
	  		}
        let reader = new FileReader();
        reader.onload = function (event) {
          document.getElementById("videoprofileresumeThumbnail").src = event.target.result
        }
        reader.readAsDataURL(f);
      });
    },
    choosepostVideoThumbnail : function() {
      document.getElementById("profileresumethumbnail").click()
    },
    openpostDetailsSection : function() {
      this.videoDetailsSection = !this.videoDetailsSection;
    },
    // this will invoke after click on draft button to save the video as a draft
    draftProfileVideoBtnClicked : function() {
      this.videoType = 'DRAFT'
      this.draftbuttonClicked = true
      this.saveProfileVideo()
    },
    draftResumeVideoBtnClicked : function() {
      this.videoType = 'DRAFT'
      this.draftbuttonClicked = true
      this.saveResumeVideo()
    },
    // this will invoke after click on save button to save the video as a post
    saveprofileVideoBtnClicked : function() {
      this.videoType = 'POST'
      this.savebuttonClicked = true;
      this.saveProfileVideo()
    },
    saveresumeVideoBtnClicked : function() {
      this.videoType = 'POST'
      this.savebuttonClicked = true;
      this.saveResumeVideo()
    },
    clearSelectedData : function() {
      console.log("clear selected data")
      this.videoTitle = '';
      this.videoDescription = '';
      this.privacy = "PUBLIC";
      this.selectedpostvideoduration = null;
      this.selectedpostVideo = null;
      this.profileresumevideothumbnail = null
    },
    //saving profile video
    saveProfileVideo : function() {
      console.log("resume post button clicked")
      console.log("selected video : ", this.selectedpostVideo)
      console.log("selected thumbnail : ", this.profileresumevideothumbnail)
      console.log("video type : ", this.videoType)
      this.videoUploadingErrorMessage = ""
      var vm = this;
      var pfd = new FormData()
      var obj = {
        profileId : this.profileId,
        videoType : this.videoType,
        videoTitle : this.videoTitle,
        videoDescription : this.videoDescription,
      }
      console.log("userVideo : ", obj)
      //prev code for duration
      // this.selectedpostvideoduration = null;
      // var duration = document.getElementById('vidprofileresume').duration
      //new code for duration
      var duration = this.selectedpostvideoduration;
      if(duration){
       var durationblob =  new Blob([JSON.stringify(duration)], { type: "application/json" })
      }
      var pblob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      pfd.append("userVideo", pblob)
      pfd.append("profileVideo", this.selectedpostVideo)
      pfd.append("profileVideoThumbnail", this.profileresumevideothumbnail)
      pfd.append("duration", durationblob)
      htttpuserprofile.put('/userprofile/uploadprofileVideo', pfd, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
        console.log(response)
        if(response.data.apiStatus == "SUCCESS"){
          console.log("saved successfully")
          if(this.videoType = 'POST') {
            vm.$toast.success("Successfully saved profile video")
            bus.$emit('successfullysavedprofileresumevideo', 'PROFILE')
          }else{
            vm.$toast.success("Successfully saved profile video as a draft")
          }
          this.savebuttonClicked = false;
          this.draftbuttonClicked = false;
          this.clearSelectedData()
          this.close();
          // vm.$toast.success("Successfully saved profile video")
        }
        if(response.data.errorCode == 1015) {
          this.videoUploadingErrorMessage = "Only 1 video will be saved as a draft"
        }
        this.savebuttonClicked = false;
        this.draftbuttonClicked = false;
      }).catch((e) => {
        console.log(e)
        this.savebuttonClicked = false;
        this.draftbuttonClicked = false;
        this.displayAPIerrorModal = true;
        setTimeout(() => {
          vm.close()   
        }, 5000);
      })

    },
    //saving resume video
    saveResumeVideo : function() {
      console.log("resume post button clicked")
      console.log("selected video : ", this.selectedpostVideo)
      console.log("selected thumbnail : ", this.profileresumevideothumbnail)
      console.log("video type : ", this.videoType)
      this.videoUploadingErrorMessage = ""
      var vm = this;
      var pfd = new FormData()
      var obj = {
        profileId : this.profileId,
        videoType : this.videoType,
        videoTitle : this.videoTitle,
        videoDescription : this.videoDescription,
      }
      console.log("userVideo : ", obj)
      //previous code for duration
      // this.selectedpostvideoduration = null;
      // var duration = document.getElementById('vidprofileresume').duration
      //new code for duration
      var duration = this.selectedpostvideoduration;
      if(duration){
       var durationblob =  new Blob([JSON.stringify(duration)], { type: "application/json" })
      }
      var pblob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      pfd.append("userVideo", pblob)
      pfd.append("resumeVideo", this.selectedpostVideo)
      pfd.append("resumeVideoThumbnail", this.profileresumevideothumbnail)
      pfd.append("duration", durationblob)
      htttpuserprofile.put('/userprofile/uploadResumeVideo', pfd, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
        console.log(response)
        if(response.data.apiStatus == "SUCCESS"){
          console.log("saved successfully")
          if(this.videoType = 'POST') {
            vm.$toast.success("Successfully saved resume video")
            bus.$emit('successfullysavedprofileresumevideo', 'RESUME')
          }else{
            vm.$toast.success("Successfully saved resume video as a draft")
          }
          this.savebuttonClicked = false;
          this.draftbuttonClicked = false;
          this.clearSelectedData()
          this.close();
          // vm.$toast.success("Successfully saved resume video")
        }
        if(response.data.errorCode == 1015) {
          this.videoUploadingErrorMessage = "Only 1 video will be saved as a draft"
        }
        this.savebuttonClicked = false;
        this.draftbuttonClicked = false;
      }).catch((e) => {
        console.log(e)
        this.savebuttonClicked = false;
        this.draftbuttonClicked = false;
        this.displayAPIerrorModal = true;
        setTimeout(() => {
          vm.close()   
        }, 5000);
      })

    },
  },
  beforeDestroy(){
    this.clearCameraEvent()
  }
}
</script>

<style>
@import '../css/modal.css';
#vidprofileresume{
  width: 100%;
  background: black;
}
</style>